import { render, staticRenderFns } from "./BitesList.vue?vue&type=template&id=56ef6d02&scoped=true"
import script from "./BitesList.vue?vue&type=script&lang=js"
export * from "./BitesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef6d02",
  null
  
)

export default component.exports